import React, { useMemo } from 'react';
import Markdown from 'react-native-markdown-display';
import truncateMarkdown from 'markdown-truncate';
import { fontWeightToFontFamilyName } from '../../../hooks/useLoadAssets';
import { textVariantStyleMap } from '../Text';
import { View } from 'react-native';

export type MarkdownDisplayOwnProps = {
    truncateLength?: number;
    children: string;
};

export type MarkdownDisplayProps = MarkdownDisplayOwnProps;

const MarkdownDisplay: React.FC<MarkdownDisplayProps> = (props) => {
    const content = useMemo(
        () =>
            props.truncateLength
                ? truncateMarkdown(props.children, { limit: props.truncateLength, ellipsis: true })
                : props.children,
        [props.children, props.truncateLength],
    );

    return (
        <View style={{ minWidth: '100%' }}>
            <Markdown
                style={{
                    body: textVariantStyleMap['body-1'],
                    strong: {
                        fontFamily: fontWeightToFontFamilyName.Overpass['semi-bold'],
                        fontWeight: '600',
                    },
                    heading1: textVariantStyleMap['h1'],
                    heading2: textVariantStyleMap['h2'],
                    heading3: textVariantStyleMap['h3'],
                    heading4: textVariantStyleMap['h4'],
                    heading5: textVariantStyleMap['h5'],
                    heading6: textVariantStyleMap['h6'],
                    span: textVariantStyleMap['body-1'],
                }}
                mergeStyle={true}
            >
                {content}
            </Markdown>
        </View>
    );
};

export default React.memo(MarkdownDisplay);
